module.exports = __webpack_public_path__ + "img/getraenkealkoholfrei.704b3d72.jpg";